/**
 * Добавляет префикс ко всем ключам объекта.
 * @param obj - Входной объект.
 * @param prefix - Префикс для добавления (например, 'p_').
 * @returns Новый объект с префиксами в ключах.
 */
export const AddPrefix = <T extends Record<string, any>>(
  obj: T,
  prefix: string
): Record<string, unknown> => {
  if (!obj || typeof obj !== 'object') {
    return {}
  }
  return Object.keys(obj).reduce((acc, key) => {
    // Проверяем, что ключ еще не имеет этого префикса
    const newKey = key.startsWith(prefix) ? key : `${prefix}${key}`
    acc[newKey] = obj[key]
    return acc
  }, {} as Record<string, unknown>)
}

/**
 * Удаляет префикс из ключей объекта.
 * @param obj - Входной объект (обычно ответ от API).
 * @param prefix - Префикс для удаления (например, 'p_').
 * @returns Новый объект с удаленными префиксами в ключах, приведенный к типу T.
 */
export const RemovePrefix = <T extends Record<string, any>>(
  obj: Record<string, any>,
  prefix: string
): T => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return {} as T
  }
  
  // Мы используем Record<string, any> для аккумулятора.
  // Это явно говорит компилятору, что acc — это изменяемый объект.
  const result = Object.keys(obj).reduce((acc: Record<string, any>, key) => {
    // Удаляем префикс, если он есть
    const newKey = key.startsWith(prefix) ? key.substring(prefix.length) : key
    acc[newKey] = obj[key] 
    return acc
  }, {})

  // 1. Приводим результат к типу T.
  // 2. Использование 'as T' здесь безопасно, так как мы знаем, что
  //    структура ключей теперь соответствует ожиданиям T.
  return result as T
}